import { create } from 'zustand'

interface IScheduleZip {
    hasStoresZip: boolean
    setHasStoresZip: (hasStoresZip: boolean) => void
}

export const useScheduleZip = create<IScheduleZip>((set) => ({
    hasStoresZip: true,
    setHasStoresZip: (hasStoresZip) => set({ hasStoresZip }),
}))
